import { PhotoType } from '@numeo/types-core'
import type { TmsInvoiceRow } from '@numeo/types-main-web-app'
import { getUserErrorMessage } from '@/utils/get-user-error-message'
import { showError, showSuccess } from '@/utils/snackbar'
import { CHAT_UPLOAD_ACCEPT, uploadToLoad } from '../uploads/uploadFlow'

/** Opens the file picker for a POD and files it on the load through the board's upload. `onUploaded` runs after a successful upload. */
export const pickPodFor = (row: TmsInvoiceRow, onUploaded: () => void): void => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = CHAT_UPLOAD_ACCEPT
    input.onchange = async () => {
        const file = input.files?.[0]
        if (!file) return
        try {
            await uploadToLoad({ loadNumber: row.load_numbers[0] ?? '', loadId: row.load_id ?? undefined, type: PhotoType.POD, file })
            showSuccess('POD uploaded. Its check runs now.')
            onUploaded()
        } catch (error) {
            showError(getUserErrorMessage(error))
        }
    }
    input.click()
}
